import { render } from "./PatchSelector.vue?vue&type=template&id=6eb77aa5"
import script from "./PatchSelector.vue?vue&type=script&lang=js"
export * from "./PatchSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../biotron-pwa-ux-runtime/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__